import React from 'react';
import Patryk from '../../assets/images/team/Patryk.webp';
import Maksymilian from '../../assets/images/team/Maks.webp';
import Adam from '../../assets/images/team/Adam.webp';
import Wiktor from '../../assets/images/team/Wiktor.webp';
import Michal from '../../assets/images/team/Michal.webp';

import { AiOutlineLinkedin } from 'react-icons/ai';
import { Trans, useTranslation } from 'react-i18next';

export default function AboutUs() {
    const { t } = useTranslation();

    function AutorBox(props: { image: string; linkedin: string; name: string; roles: string[] }) {
        return (
            <a href={props.linkedin} rel={'noreferrer'} target={'_blank'} className={'flex'}>
                <div className={'group flex cursor-pointer flex-col rounded border shadow'}>
                    <img
                        src={props.image}
                        alt={props.name}
                        className={
                            'mb-1 h-80 w-64 rounded-t object-cover object-top transition-all group-hover:brightness-50'
                        }
                    />

                    <div
                        className={
                            'absolute hidden h-80 w-64 items-center justify-center group-hover:flex'
                        }>
                        <AiOutlineLinkedin size={40} className={'text-white'} />
                    </div>

                    <div className={'px-4 py-2'}>
                        <h3 className={'text-xl'}>{props.name}</h3>
                        <div
                            className={
                                'mb-2 h-0.5 w-6 rounded-xl bg-SM-yellow transition-all group-hover:w-36'
                            }
                        />
                        {props.roles.map((role, index) => {
                            return (
                                <p
                                    className={'font-montserrat text-sm'}
                                    key={`role-${props.name}-${index}`}>
                                    {role}
                                </p>
                            );
                        })}
                    </div>
                </div>
            </a>
        );
    }

    return (
        <div className={'my-6'}>
            <div className={'margin'}>
                <h1 className={'mb-3 text-center text-3xl font-medium sm:text-4xl'}>
                    {t('ABOUT_US.OUR_TEAM')}
                </h1>
                <div className={'flex flex-wrap justify-center gap-5'}>
                    <AutorBox
                        name={'Patryk Rusak'}
                        linkedin={'https://www.linkedin.com/in/patryk-rusak/'}
                        image={Patryk}
                        roles={['Website Developer', 'Marketing manager']}
                    />

                    <AutorBox
                        name={'Maksymilian Zbroja'}
                        linkedin={'https://www.linkedin.com/in/maksymilian-zbroja-8a5b73249/'}
                        image={Maksymilian}
                        roles={['Product Manager', 'UX/UI']}
                    />

                    <AutorBox
                        name={'Wiktor Nedew'}
                        linkedin={'https://www.linkedin.com/in/wiktor-nedew-0a7657247/'}
                        image={Wiktor}
                        roles={['Lead Backend Developer']}
                    />

                    <AutorBox
                        name={'Adam Kalinowski'}
                        linkedin={'https://www.linkedin.com/in/kalinowskyyy/'}
                        image={Adam}
                        roles={['Core Developer', 'App Developer']}
                    />

                    <AutorBox
                        name={'Michał Łukasiak'}
                        linkedin={
                            'https://www.linkedin.com/in/micha%C5%82-%C5%82ukasiak-631507243/'
                        }
                        image={Michal}
                        roles={['Partnership Manager']}
                    />
                </div>
            </div>
            <p className={'margin mt-3 text-center text-slate-700'}>
                <b>Podziękowania dla:</b> Mateusz Łojewski i Weronika Woroszczuk
            </p>
            <div className={'mt-5'}>
                <h2
                    className={
                        'mb-3 w-fit bg-SM-yellow py-2 pl-[6vw] pr-3 text-lg text-white sm:text-2xl'
                    }>
                    {t('ABOUT_US.WHO_WE_ARE_TITLE')}
                </h2>
                <p className={'mx-[10vw] text-sm sm:text-base'}>
                    {t('ABOUT_US.WHO_WE_ARE_CONTENT')}
                </p>
            </div>

            <div className={'mt-8'}>
                <h2
                    className={
                        'mb-3 w-fit bg-SM-yellow py-2 pl-[6vw] pr-3 text-lg text-white sm:text-2xl'
                    }>
                    {t('ABOUT_US.HOW_SM_WAS_CREATED_TITLE')}
                </h2>
                <p className={'mx-[10vw] text-sm sm:text-base'}>
                    {t('ABOUT_US.HOW_SM_WAS_CREATED_CONTENT')}
                </p>
            </div>

            <div className={'mt-8'}>
                <h2
                    className={
                        'mb-3 w-fit bg-SM-yellow py-2 pl-[6vw] pr-3 text-lg text-white sm:text-2xl'
                    }>
                    {t('ABOUT_US.OUR_ACHIEVEMENTS')}
                </h2>
                <p className={'mx-[10vw] text-sm sm:text-base'}>
                    <Trans
                        i18nKey={'translation:ABOUT_US.OUR_ACHIEVEMENTS_CONTENT'}
                        components={[<br key={'br'} />, <strong key={'strong'} />]}
                    />
                </p>
            </div>
        </div>
    );
}
